
import { DandDFeatureSource } from "@dndModels/feature_sources/SystemFeatureSource";
import { DataType } from "@dndModels/Types";
import { 
  Feature,
  FeatureBase,
  // Limitation 
} from "@models";

/**
 * Eldritch Invocations are a lot like Feats, 
 * but it's a different set, and they generally
 * only go to Warlocks.
 */

export class EldritchInvocation extends DandDFeatureSource {
  data_type: DataType = "eldritch_invocation";
  feature_source_type = "EldritchInvocation";
  repeatable = false;

  constructor(obj?: any) {
    super(obj, "EldritchInvocation");
    if (obj) {
      if (this.feature_bases.length === 0 && obj.features && obj.features.length > 0) {
        const features: Feature[] = [];
        obj.features.forEach((o: any) => {
          o.source_id = this._id;
          o.source_type = this.feature_source_type;
          const feature = new Feature(o);
          features.push(feature);
        });
        const feature_base = new FeatureBase();
        feature_base.feature_source_id = this._id;
        feature_base.feature_source_type = this.feature_source_type;
        feature_base.features = features;
        this.feature_bases.push(feature_base);
      }
      this.repeatable = obj.repeatable ? obj.repeatable : false;
    }
  }

  // load(obj: any): void {
  //   super.load(obj);
  //   if (obj) {
  //     if (this.feature_bases.length === 0 && obj.features && obj.features.length > 0) {
  //       const features: Feature[] = [];
  //       obj.features.forEach((o: any) => {
  //         o.source_id = this._id;
  //         o.source_type = this.feature_source_type;
  //         const feature = new Feature(o);
  //         features.push(feature);
  //       });
  //       const feature_base = new FeatureBase();
  //       feature_base.feature_source_id = this._id;
  //       feature_base.feature_source_type = this.feature_source_type;
  //       feature_base.features = features;
  //       this.feature_bases.push(feature_base);
  //     }
  //     this.repeatable = obj.repeatable ? obj.repeatable : false;
  //   }
  // }

  get pact_boon_ids(): string[] {
    return this.limitations.filter(o => o.type === "pact_boon").flatMap(o => o.ids);
  }

  toDBObj(): any {
    const feature_source_obj = super.toDBObj();
    return {
      ...feature_source_obj,
      repeatable: this.repeatable
    };
  }

  toLight(): any {
    const feature_source_obj = super.toLight();
    return {
      ...feature_source_obj,
      repeatable: this.repeatable
    };
  }

  copy(copyMe: EldritchInvocation, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    this.repeatable = copyMe.repeatable;
  }

  clone(drop_ids = false): EldritchInvocation {
    const new_obj = new EldritchInvocation();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }

  copy5e(copyMe: any): void {
    this.name = copyMe.name.substring(21);
    this.description = "";
    copyMe.desc.forEach((d: any) => {
      this.description += d + "\n ";
    });
  }
}